/**
 * Graphology Classic Graph Generators
 * ====================================
 *
 * Classic graph generators endpoint.
 */
exports.complete = require('./complete.js');
exports.empty = require('./empty.js');
exports.ladder = require('./ladder.js');
exports.path = require('./path.js');
